import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";
import { articleList } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-800 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="font-heading text-xl font-semibold text-background-50 tracking-tight"
            >
              BaseTao<span className="text-primary-400">Sheet</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed max-w-xs">
              The most comprehensive English resource for BaseTao Spreadsheet guides, reviews, shipping tips, and tutorials for international shoppers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  BaseTao Spreadsheet
                </a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Buy It Now
                </a>
              </li>
              {articleList.slice(0, 5).map((article) => (
                <li key={article.slug}>
                  <Link to={`/article/${article.slug}`} className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    {article.title.length > 45 ? article.title.slice(0, 45) + "..." : article.title}
                  </Link>
                </li>
              ))}
              {articleList.length > 5 && (
                <li>
                  <Link to="/" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer">
                    View All Guides
                    <i className="ri-arrow-right-line ml-1 text-xs"></i>
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Product Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 BaseTaoSheet.top. All rights reserved. This is an independent educational resource.
          </p>
          <div className="flex items-center gap-6">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}